import { OperationProblem } from '../../../../gamma-api';

export enum StatusInfoTheme {
  Green = 'green',
  Blue = 'blue',
}

export enum StatusInfoState {
  Wait = 'wait',
  Pause = 'pause',
  Process = 'process',
  Finish = 'finish',
  Error = 'error',
}

export interface IStatusInfoItem {
  title?: string;
  subtitle?: string;
  description?: string;
  problem?: OperationProblem | null;
  theme?: StatusInfoTheme;
  status?: StatusInfoState;
  modal?: boolean;
}
